import React, { Component } from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';

import HomePage from './home';
import SearchPage from './search';
import WeatherPage from './weather';

import './App.css';

class App extends Component {
    render() {
        return (
            <HashRouter basename="/" hashType="slash">
            <Switch>
                <Route 
                    exact path={'/'} 
                    render={props => <HomePage key="page_home" {...props} />}
                ></Route>
                <Route 
                    path={'/weather/:woeid'} 
                    render={props => <WeatherPage key="page_weather" {...props} />}
                ></Route>
                <Route 
                    path={'/search/:term'}
                    render={props => <SearchPage key={'page_search_'+props.match.params.term.toLowerCase()} {...props} />}
                ></Route>
            </Switch>
            </HashRouter>
        );
    }
}

export default App;
